module.exports = __webpack_public_path__ + "static/media/google-plus.34e19bf1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/common/Auth/assets/google-plus.svg
// module id = ./src/common/Auth/assets/google-plus.svg
// module chunks = 14